<template>

<div>
    <div v-if="vraag && vraag.tree && vraagId">
        <h3>{{ vraag.omschrijving }}</h3>
        <TreeSelect :tree="vraag.tree" :rules="rules" :vraagId="vraagId" v-model="answers" />
    </div>
</div>


</template>

<script>

import TreeSelect from "./TreeSelect.vue";
import { mapActions } from "vuex";

export default {
    name: "TreeForm", 
    props: {
        vraag: {
            type: Object,
            required: true
        },
        rules: {
            type: Array,
            required: false
        }
    },
    components: {
        TreeSelect
    },

    watch: {
        vraag: {
            immediate: true,
            handler(newVal, oldVal) {
                if (oldVal != null) {


                    newVal.tree.filter(f => f.level === 2).forEach(fe => {
                        if (fe.criteria != this.tweedeVraag.reactie) {
                            const onderliggendeIds = this.collectChildIds(fe.id);
                            if (onderliggendeIds.length > 0) {
                                this.removeAntwoorden(onderliggendeIds);
                            }
                        }
                    }); 


                }
            }
        }
    },
    data() {
        return {
            tree: [{ "id": 238, "omschrijving": "Heb jij het diploma Basistheorie Vastgoeddeskundige behaald?", "level": 1, "criteria": "WOZ-taxateur woningen" }, { "id": 239, "vraagid": 238, "omschrijving": "Heb jij basisdiploma WOZ behaald?", "level": 2, "criteria": "ja" }, { "id": 245, "vraagid": 238, "omschrijving": "Heb jij basisdiploma WOZ behaald?\r\n", "level": 2, "criteria": "nee" }, { "id": 246, "vraagid": 245, "omschrijving": "Heb jij het certificaat WOZ-taxateur woningen behaald?\r\n", "level": 3, "criteria": "ja" }, { "id": 240, "vraagid": 239, "omschrijving": "Heb jij het certificaat WOZ-taxateur woningen behaald?", "level": 3, "criteria": "ja" }, { "id": 241, "vraagid": 240, "omschrijving": "Heb jij de vakvaardighedenmodule WOZ-taxateur woningen behaald?", "level": 4, "criteria": "ja" }, { "id": 242, "vraagid": 240, "omschrijving": "Ben je ingeschreven als NRVT taxateur woningen?\r\n", "level": 4, "criteria": "nee" }, { "id": 247, "vraagid": 246, "omschrijving": "Heb jij de HALO behaald?\r\n", "level": 4 }, { "id": 248, "vraagid": 247, "omschrijving": "Heb jij het afgelopen jaar incompany trainingen gevolgd?\r\n", "level": 5 }, { "id": 243, "vraagid": 242, "omschrijving": "Heb jij de HALO behaald?\r\n", "level": 5 }, { "id": 244, "vraagid": 243, "omschrijving": "Heb jij het afgelopen jaar incompany trainingen gevolgd?\r\n", "level": 6 }],
            tree2: null,
            answers: {}
        };
    },
    computed: {
        tweedeVraag() {
            if (!this.vraag || !this.vraag.tree) return null;
            // Vervang 'getVraagById' door de naam van jouw getter
            return this.$store.getters.getVraag(this.vraag.vraag_id);
            //return this.$store.state.antwoorden.find(a => a.vraag_id === this.vraag.vraag_id);
        },
        vraagId() {
            if (!this.vraag || !this.vraag.tree || !this.tweedeVraag) return null;
            return this.vraag.tree?.find(item => item.criteria === this.tweedeVraag.reactie)?.id
        }
    },
    methods: {
        ...mapActions(["removeAntwoorden"]),
        collectChildIds(parentId) {
            const ids = [];
            const children = this.vraag.tree.filter(q => q.vraagid === parentId);
            for (const child of children) {
                ids.push(child.id);
                ids.push(...this.collectChildIds(child.id));
            }
            return ids;
        }
    }


}
</script>